/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindFileQueryResponse } from './FindFileQueryResponse';
import {
    FindFileQueryResponseFromJSON,
    FindFileQueryResponseFromJSONTyped,
    FindFileQueryResponseToJSON,
} from './FindFileQueryResponse';

/**
 * 
 * @export
 * @interface DataFindFileQueryResponse
 */
export interface DataFindFileQueryResponse {
    /**
     * 
     * @type {Array<FindFileQueryResponse>}
     * @memberof DataFindFileQueryResponse
     */
    data: Array<FindFileQueryResponse>;
}

/**
 * Check if a given object implements the DataFindFileQueryResponse interface.
 */
export function instanceOfDataFindFileQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DataFindFileQueryResponseFromJSON(json: any): DataFindFileQueryResponse {
    return DataFindFileQueryResponseFromJSONTyped(json, false);
}

export function DataFindFileQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataFindFileQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FindFileQueryResponseFromJSON)),
    };
}

export function DataFindFileQueryResponseToJSON(value?: DataFindFileQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FindFileQueryResponseToJSON)),
    };
}

